export class FileExplorerCountSecurityAlertsInResourceResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FileExplorerCountSecurityAlertsInResourceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
